import logo from "./logo.svg";
import "./App.css";
import React from "react";
import { Container, Row, Col } from "react-bootstrap"; // Asegúrate de tener React Bootstrap instalado
import Home from "./Home";
import MapView from "./MapView";
import Footer from "./Template/Footer.js";

function App() {
  return (
    <div style={{height: "100dvh"}}>
    <Home></Home>
    {/* <header
      style={{
      
        top: 0,
        width: '100%',
        backgroundColor: '#f8fbfe',
        zIndex: 1000,
        padding: '10px 0',
      }}
    >
      <Container>
        <Row className="align-items-center">
      
          <Col xs="auto" className="d-flex align-items-center">
            <a href="https://www.crsolponiente.es/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
              <img
                src="https://www.crsolponiente.es/wp-content/uploads/2018/10/solponientetorrelogo.png"
                alt="CR SOLPONIENTE"
                style={{ height: '60px', width: 'auto' }} // La imagen está pegada al inicio
              />
            </a>
          </Col>
    
          <Col className="text-center">
            <h4 style={{ color: '#333333', fontSize: '14px', margin: 0 }}>
              Parcelario Solponiente
            </h4>
          </Col>
        </Row>
      </Container>
    </header> */}
    </div>
  );
}

export default App;
